import config from "@/config";
import { requests } from ".";

const PAYMENT_SERVER_URL = config?.PAYMENT_SERVER_URL;
const PAYMENT_BACKEND_URL = config?.PAYMENT_BACKEND_URL || PAYMENT_SERVER_URL;
const PRODUCT_SERVER_URL = config?.PRODUCT_SERVER_URL;

interface PRODUCT_LIST {
  locationId: string;
  search?: string;
  skip?: number;
  offset?: number;
  limit?: number;
  productIds?: Array<string>;
}

interface CREATE_PRODUCT {
  locationId: string;
  name: string;
  productType: string;
  medias: Array<string>;
  availableInStore: boolean;
  seo: {
    title: string;
    description: string;
  };
  variants: Array<string>;
  isTaxesEnabled: boolean;
  isLabelEnabled: boolean;
  prices: Array<PRODUCT_PRICE>;
  meta: {
    internalSource: string;
  };
}

interface PRODUCT_PRICE {
  name: string;
  type: string;
  currency: string;
  amount: number;
  recurring: {
    interval: string;
    intervalCount: number;
  };
}

interface EnableBillingAddressFieldsResponse {
  status: boolean;
  message?: string;
}

export const PaymentServices = {
  integrations: (locationId: string) =>
    requests(PAYMENT_SERVER_URL).get(`/payments/integrations/${locationId}`),
  getEntityProviders: (params: {
    locationId: string;
    liveMode: boolean;
    entityType: "forms" | "surveys";
  }) =>
    requests(PAYMENT_BACKEND_URL).get("/payments/integrations/entity-providers", {
      params: {
        liveMode: params.liveMode,
        altId: params.locationId,
        altType: "location",
        includeDefault: true,
        entityType: params.entityType,
      },
    }),
  getCurrency: () => requests(PAYMENT_SERVER_URL).get("/payments/currency"),
  getProductList: (params: PRODUCT_LIST) =>
    requests(PRODUCT_SERVER_URL).get("/products/", {
      params: params,
    }),
  createProduct: (body: CREATE_PRODUCT) => requests(PRODUCT_SERVER_URL).post("/products/", body),
  enableBillingAddressFields: (locationId: string) =>
    requests(PAYMENT_BACKEND_URL).post<EnableBillingAddressFieldsResponse>(
      "/leadgen-common/custom-field/billing-address",
      { altType: "location", altId: locationId }
    ),
};
